import React, { useState } from 'react'
import { getUserChart } from 'src/services/api/charts'
import { Props } from './types'
import { Chart } from '../components/chart'
import { utilData } from '../components/util-data'

const chartData = {
  chart: {
    renderTo: 'container',
    type: 'column',
    options3d: {
      enabled: true,
      alpha: 15,
      beta: 15,
      depth: 50,
      viewDistance: 25
    }
  },
  xAxis: {
    categories: [] as any
  },
  yAxis: {
    title: {
      enabled: false
    }
  },
  tooltip: {
    headerFormat: '<b>{point.key}</b><br>',
    pointFormat: 'Valor: R$ {point.y:.2f}'
  },
  title: {
    text: 'Usuários com maior volume de despesas',
    align: 'center'
  },
  subtitle: {
    text: '',
    align: 'left'
  },
  legend: {
    enabled: false
  },
  exporting: {
    enabled: true
  },
  plotOptions: {
    column: {
      depth: 25
    }
  },
  series: [
    {
      data: [] as any,
      colorByPoint: true
    }
  ]
}

function updateChatData(categories: [], series: []) {
  return {
    ...chartData,
    series: [
      {
        data: series,
        colorByPoint: true
      }
    ],
    xAxis: {
      categories
    }
  }
}

export default function ReceiptsByUser({ organization_id }: Props) {
  const [isLoading, setIsLoading] = useState(false)

  async function updateChart(monthFilter: string) {
    if (!monthFilter) {
      return chartData
    }

    setIsLoading(true)
    const date_end = utilData(monthFilter)
    const response = await getUserChart(
      organization_id,
      monthFilter,
      date_end,
      5
    )

    setIsLoading(false)
    if (response.status !== 200) {
      return updateChatData([], [])
    }

    return updateChatData(
      response.data.data.categories,
      response.data.data.series
    )
  }

  return <Chart updateChart={updateChart} isLoading={isLoading} />
}
